import { render, staticRenderFns } from "./TrainingSegment.vue?vue&type=template&id=db1f6236"
import script from "./TrainingSegment.vue?vue&type=script&lang=js"
export * from "./TrainingSegment.vue?vue&type=script&lang=js"
import style0 from "./TrainingSegment.vue?vue&type=style&index=0&id=db1f6236&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports